var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from "./component";
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(args) {
        var _this = _super.call(this, args) || this;
        _this.name = "carousel";
        return _this;
    }
    Object.defineProperty(Carousel.prototype, "indicators", {
        get: function () {
            if (this.composer.indicators) {
                return Array.isArray(this.composer.indicators)
                    ? this.composer.indicators
                    : this.composer.indicators.querySelectorAll('.carousel-indicator');
            }
            else {
                this.element.querySelectorAll('.carousel-indicator');
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "controls", {
        get: function () {
            if (this.composer.controls) {
                return Array.isArray(this.composer.controls)
                    ? this.composer.controls
                    : this.composer.controls.querySelectorAll('.carousel-control');
            }
            else {
                this.element.querySelectorAll('.carousel-control');
            }
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.init = function () {
        var _this = this;
        var _a, _b;
        _super.prototype.init.call(this);
        (_a = this.indicators) === null || _a === void 0 ? void 0 : _a.forEach(function (indicator) {
            indicator.addEventListener('click', function (event) {
                var _a;
                var activeIndicator = event.currentTarget;
                (_a = _this.indicators) === null || _a === void 0 ? void 0 : _a.forEach(function (i) { return i.classList.remove('active'); });
                activeIndicator.classList.add('active');
                console.log(indicator.getAttribute('data-ll-carousel-index'), 'caoursel index');
                _this.componentInstance.to(indicator.getAttribute('data-ll-carousel-index'));
            });
        });
        (_b = this.controls) === null || _b === void 0 ? void 0 : _b.forEach(function (control) {
            control.addEventListener('click', function () {
                console.log('control click');
                var direction = control.getAttribute('data-ll-carousel-direction');
                _this.componentInstance[direction]();
            });
        });
    };
    Carousel.prototype.render = function () {
        this.setElement();
        this.init();
        return this.element;
    };
    return Carousel;
}(Component));
export { Carousel };
